import React from 'react';
import styles from './Tabs.module.scss';
import classnames from 'classnames/bind';
import { Typography } from '../Typography/Typography';
import { useTabs } from './TabsProvider';

const cx = classnames.bind(styles);

interface TabProps {
  id: string;
  tabText: string;
}

export const Tab = ({ id, tabText }: TabProps) => {
  const { activeTab, setActiveTab } = useTabs();
  const active = activeTab === id;
  return (
    <button
      id={id}
      role="tab"
      aria-selected={active}
      onClick={() => setActiveTab(id)}
      className={cx('tab', { active })}
    >
      <Typography size="L" weight={active ? 'bold' : 'semi-bold'}>
        {tabText}
      </Typography>
      <div className={cx('underline', { active })}></div>
    </button>
  );
};
